module.exports = __webpack_public_path__ + "img/emporia_bern_ocular-2.07441e65.jpg";